import { Body } from 'components/text';
import { FC } from 'react';
import { NavMenus } from '../contants';
import Container from 'components/container';

interface INavigation {
  scrollToSection: (id: string) => void;
}

const Navigation: FC<INavigation> = ({ scrollToSection }) => {
  return (
    <Container className="nav-section" as="section">
      <div className="nav-section__container">
        {NavMenus.map((menu, index) => {
          return (
            <div
              key={index}
              className="nav-section__title"
              onClick={() =>
                scrollToSection(menu.replace(/\s/g, '-').toLowerCase())
              }
            >
              <Body color="grey-dark">{menu} </Body>
              <div className="nav-section__divider" id="divider"></div>
            </div>
          );
        })}
      </div>
    </Container>
  );
};

export default Navigation;
